import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type FooterType = 'default' | 'summaryBar';

interface ActionFooterState {
    footerType: FooterType;
    actionFooterData: {
        totalCost: number | string;
        currency: string;
    };
}

const initialState: ActionFooterState = {
    footerType: 'default',
    actionFooterData: {
        totalCost: '0',
        currency: '',
    },
};

const actionFooterSlice = createSlice({
    name: 'actionFooter',
    initialState,
    reducers: {
        setFooterType: (state, action: PayloadAction<FooterType>) => {
            state.footerType = action.payload;
        },

        resetFooter: (state) => {
            state.footerType = 'default';
            state.actionFooterData = {
                totalCost: '0',
                currency: '',
            };
        },
    },
});

export const { setFooterType } = actionFooterSlice.actions;
export default actionFooterSlice.reducer;
